import { GroupsService } from 'data/services';
import { GroupsServiceInterface } from 'domain/services';
import { makeGetAllGroupsUser } from 'main/factories/usecases/groups/remote-get-all-groups-user-factory';

export const makeGroupsService = (): GroupsServiceInterface => {
  return new GroupsService({
    getAllGroupsUser: makeGetAllGroupsUser(),
  });
};
